// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"571":"278a104a","631":"91f77e41"}[chunkId] + ".chunk.css";
};